import ProductAuthorPreview from "./product-author-preview";

export default ProductAuthorPreview;